import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/passenger-fill-green.svg'
import _imports_1 from '@/assets/img/icon/list-check-fill-blue.svg'
import _imports_2 from '@/assets/img/icon/times-background-red.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "font-extrabold text-xl" }, "Log Penumpang", -1)
const _hoisted_4 = { class: "text-primary font-bold text-3xl" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = { class: "font-bold text-base" }
const _hoisted_7 = { class: "text-grey text-base font-normal" }
const _hoisted_8 = { class: "grid md:grid-cols-2 lg:grid-cols-3 gap-3 mb-4" }
const _hoisted_9 = { class: "border-grey-2 rounded-xl p-4" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "text-xl font-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-base font-normal" }, "Total Penumpang Bus", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-7",
    alt: "bus-full"
  })
], -1)
const _hoisted_14 = { class: "border-grey-2 rounded-xl p-4" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = { class: "text-xl font-bold" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-base font-normal" }, "Total Penumpang Check In", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-7",
    alt: "bus-full"
  })
], -1)
const _hoisted_19 = { class: "border-grey-2 rounded-xl p-4" }
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "text-xl font-bold" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-base font-normal" }, "Total Tiket Hangus", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "w-7",
    alt: "bus-full"
  })
], -1)
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_26 = { class: "text-primary font-bold" }

import moment from 'moment'
import {
  reactive,
  ref,
  toRefs,
  computed,
  getCurrentInstance,
  onMounted
} from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import store from '@/store'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'PassengerLog',
  setup(__props) {

const endpointBookingDraft = 'transaction/v1/BookingDraft'

const app = getCurrentInstance()
const {
  $icon,
  $toast
} = app!.appContext.config.globalProperties
const dataRow = ref(store.state.hjpTable.modal.data)
const dataSource = ref(null) as any
const dummy = [
  {
    bookingCode: '0000000',
    bookDate: moment().format('DD MMM YYYY HH:mm:ss'),
    ticketCode: '0000000',
    checkInDate: moment().format('DD MMM YYYY HH:mm:ss'),
    lastStatus: 'Check In'
  },
  {
    bookingCode: '0000000',
    bookDate: moment().format('DD MMM YYYY HH:mm:ss'),
    ticketCode: '0000000',
    checkInDate: moment().format('DD MMM YYYY HH:mm:ss'),
    lastStatus: 'Expired'
  },
  {
    bookingCode: '0000000',
    bookDate: moment().format('DD MMM YYYY HH:mm:ss'),
    ticketCode: '0000000',
    checkInDate: moment().format('DD MMM YYYY HH:mm:ss'),
    lastStatus: 'Book'
  }
]
const isLoading = ref(true)

const getLogPassenger = async () => {
  try {
    const { result, error, message } = await apiUseCase.get(`${endpointBookingDraft}/BookingDraftPassengerLogs/${dataRow.value.Id}`)
    if (!error) {
      dataSource.value = result
      console.log('dataSource', result)
      isLoading.value = false
    } else {
      $toast.add({
        severity: 'error',
        detail: message,
        group: 'bc',
        closable: false,
        life: 3000
      })
      isLoading.value = false
    }
  } catch (error) {
    console.log(error)
    isLoading.value = false
  }
  store.dispatch('hideLoading')
}

onMounted(() => {
  console.log('state', dataRow.value)
  store.dispatch('showLoading')
  getLogPassenger()
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(dataRow.value.RegNumber), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(dataRow.value.MsRouteName), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(`(${dataRow.value.DepartureTime.slice(0, 5)})`), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(`${_unref(dataSource)?.SeatBooking ?? '0'} Penumpang`), 1),
                _hoisted_12
              ]),
              _hoisted_13
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(`${_unref(dataSource)?.SeatCheckin ?? '0'} Check In`), 1),
                _hoisted_17
              ]),
              _hoisted_18
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(`${_unref(dataSource)?.SeatExpired ?? '0'} Tiket Hangus`), 1),
                _hoisted_22
              ]),
              _hoisted_23
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_unref(DataTable), {
            value: _unref(dataSource).BookingDraftLogs,
            paginator: "",
            rows: 5,
            rowsPerPageOptions: [5, 10, 20, 50],
            scrollable: ""
          }, {
            empty: _withCtx(() => [
              _hoisted_25
            ]),
            loading: _withCtx(() => [
              _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(Column), {
                field: "BookingCode",
                header: "Kode Booking",
                style: {"min-width":"110px"}
              }, {
                body: _withCtx(({ data, field }) => [
                  _createElementVNode("p", _hoisted_26, _toDisplayString(data[field]), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "BookingDate",
                header: "Jam Booking",
                style: {"min-width":"110px"}
              }, {
                body: _withCtx(({ data, field }) => [
                  _createElementVNode("p", null, _toDisplayString(_unref(moment)(data[field].toString()).format('DD MMM YYYY HH:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "TicketCode",
                header: "Kode Tiket",
                style: {"min-width":"110px"}
              }, {
                body: _withCtx(({ data, field }) => [
                  _createElementVNode("p", null, _toDisplayString(data[field] ?? '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "CheckinDate",
                header: "Jam Check In",
                style: {"min-width":"110px"}
              }, {
                body: _withCtx(({ data, field }) => [
                  _createElementVNode("p", null, _toDisplayString(data[field] ? _unref(moment)(data[field].toString()).format('DD MMM YYYY HH:mm:ss') : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), {
                field: "BookingStatus",
                header: "Status Terakhir",
                style: {"min-width":"110px"}
              }, {
                body: _withCtx(({ data, field }) => [
                  _createElementVNode("p", null, _toDisplayString(data[field]), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})